import styled, { keyframes } from "styled-components"

const fadeOut = keyframes`
  from{
    opacity: 0
  }to{
    opacity: 1
  }
`

export const Container = styled.div`
  width: 100dvw;
  height: 100dvh;
  background: rgba(0,0,0,.9);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  display: flex;
  flex-direction: column;
  align-items: center;
`;



export const ImgContainer = styled.div`
  width: 80%;
  height: 90dvh;
  max-height: 100dvh;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  >img{
    max-width: 100%;
    max-height: calc(100dvh - 80px);
    align-self: center;
  }
`

export const Header = styled.div`
  background: #000;
  width: 100%;
  padding: 10px 80px 10px;
  display: flex;
  align-items: center;
  
  justify-content: flex-end;  
  margin-bottom: 10px;
  gap: 20px;
  >button{
    border:none;
    background: none;
    color: #fff;
    cursor: pointer;
  }

  @media (max-width: 600px) {
    padding-inline: 30px;
  }
`
